/**
 * Vertex API Helper - Rutas adaptativas para desarrollo y producción
 * 
 * ✅ PATRÓN ADAPTATIVO:
 * - Desarrollo: Rutas relativas + Vite proxy → localhost:3004
 * - Producción: Rutas relativas + Nginx proxy → localhost:3004
 * 
 * ✅ VENTAJAS:
 * - CERO cambios de código entre entornos
 * - CORS automáticamente resuelto
 * - Fácil debugging con logs de proxy
 */

/**
 * Base URL para todas las peticiones a Vertex API
 * 
 * Desarrollo: '/api/vertex' → Vite proxy → http://localhost:3004/api/vertex
 * Producción: '/api/vertex' → Nginx proxy → http://localhost:3004/api/vertex
 */
export const VERTEX_API_BASE = '/api/vertex';

/**
 * @deprecated Solo para debugging o casos excepcionales
 * Usar VERTEX_API_BASE (ruta relativa) en su lugar
 */
export const getVertexBackendUrl_LEGACY = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3004';
  }
  return 'https://edutechpulselab.com';
};
